module.exports = __webpack_public_path__ + "static/img/main-accommodation-menu-img02.b166d3a5.svg";